function $995b230258b46624$export$236cfce0883632ce(boxes, thickness) {
    const panels = [];
    for (const box of boxes){
        const { name: name, width: width, depth: depth, height: height, quantity: quantity = 1 } = box;
        // Front & Back: full width × height
        const frontBackWidth = width;
        // Left & Right Sides: depth minus front/back thickness on both sides
        const sideWidth = depth - 2 * thickness;
        // Determine which panels are "Long" vs "Short" based on panel width
        const frontBackLabel = frontBackWidth >= sideWidth ? "Long" : "Short";
        const sideLabel = sideWidth > frontBackWidth ? "Long" : "Short";
        panels.push({
            boxName: name,
            label: frontBackLabel,
            width: frontBackWidth,
            height: height,
            quantity: 2 * quantity
        });
        panels.push({
            boxName: name,
            label: sideLabel,
            width: sideWidth,
            height: height,
            quantity: 2 * quantity
        });
        // Base: fits inside all four walls
        panels.push({
            boxName: name,
            label: "Base",
            width: width - 2 * thickness,
            height: depth - 2 * thickness,
            quantity: 1 * quantity
        });
    }
    return panels;
}


const $60c3b581f75a020b$export$dbae94b378a6c4a2 = {
    width: 700,
    height: 500,
    margin: 5,
    kerf: 1,
    thickness: 5
};
function $60c3b581f75a020b$export$e2b09b029fd57ee9(config) {
    return {
        width: config.width - 2 * config.margin,
        height: config.height - 2 * config.margin
    };
}
/**
 * Expand panels by quantity into individual instances and sort by area (largest first)
 */ function $60c3b581f75a020b$var$expandAndSortPanels(panels) {
    const instances = [];
    for (const panel of panels)for(let i = 0; i < panel.quantity; i++)instances.push({
        panel: panel,
        instanceIndex: i,
        width: panel.width,
        height: panel.height
    });
    // Sort by area descending (largest first)
    instances.sort((a, b)=>b.width * b.height - a.width * a.height);
    return instances;
}
/**
 * Check if a panel fits in a free rectangle (with optional rotation)
 */ function $60c3b581f75a020b$var$tryFit(panelWidth, panelHeight, rect, kerf, isFirstInRect) {
    // Add kerf to panel dimensions unless it's the first panel touching this edge
    const effectiveWidth = panelWidth + (isFirstInRect ? 0 : kerf);
    const effectiveHeight = panelHeight + (isFirstInRect ? 0 : kerf);
    // Try without rotation
    if (effectiveWidth <= rect.width && effectiveHeight <= rect.height) return {
        fits: true,
        rotated: false,
        effectiveWidth: effectiveWidth,
        effectiveHeight: effectiveHeight
    };
    // Try with rotation
    const rotatedEffectiveWidth = panelHeight + (isFirstInRect ? 0 : kerf);
    const rotatedEffectiveHeight = panelWidth + (isFirstInRect ? 0 : kerf);
    if (rotatedEffectiveWidth <= rect.width && rotatedEffectiveHeight <= rect.height) return {
        fits: true,
        rotated: true,
        effectiveWidth: rotatedEffectiveWidth,
        effectiveHeight: rotatedEffectiveHeight
    };
    return null;
}
/**
 * Split a free rectangle after placing a panel using guillotine cuts.
 * Returns new free rectangles created by the split.
 */ function $60c3b581f75a020b$var$guillotineSplit(rect, placedWidth, placedHeight, kerf) {
    const newRects = [];
    // Add kerf to create space between panels
    const usedWidth = placedWidth + kerf;
    const usedHeight = placedHeight + kerf;
    // Right rectangle (to the right of the placed panel)
    const rightWidth = rect.width - usedWidth;
    if (rightWidth > 0) newRects.push({
        x: rect.x + usedWidth,
        y: rect.y,
        width: rightWidth,
        height: rect.height
    });
    // Bottom rectangle (below the placed panel)
    const bottomHeight = rect.height - usedHeight;
    if (bottomHeight > 0) newRects.push({
        x: rect.x,
        y: rect.y + usedHeight,
        width: usedWidth - kerf,
        height: bottomHeight
    });
    return newRects;
}
/**
 * Find the best free rectangle for a panel (smallest area that fits - Best Area Fit)
 */ function $60c3b581f75a020b$var$findBestFit(panelWidth, panelHeight, freeRects, kerf) {
    let bestIndex = -1;
    let bestRotated = false;
    let bestArea = Infinity;
    let bestEffectiveWidth = 0;
    let bestEffectiveHeight = 0;
    for(let i = 0; i < freeRects.length; i++){
        const rect = freeRects[i];
        // First panel in a rect doesn't need kerf on the edges touching the rect boundary
        const fit = $60c3b581f75a020b$var$tryFit(panelWidth, panelHeight, rect, kerf, true);
        if (fit && fit.fits) {
            const area = rect.width * rect.height;
            if (area < bestArea) {
                bestArea = area;
                bestIndex = i;
                bestRotated = fit.rotated;
                bestEffectiveWidth = fit.effectiveWidth;
                bestEffectiveHeight = fit.effectiveHeight;
            }
        }
    }
    if (bestIndex === -1) return null;
    return {
        rectIndex: bestIndex,
        rotated: bestRotated,
        effectiveWidth: bestEffectiveWidth,
        effectiveHeight: bestEffectiveHeight
    };
}
/**
 * Calculate efficiency as percentage of usable area filled
 */ function $60c3b581f75a020b$var$calculateEfficiency(placements, usableWidth, usableHeight) {
    const usableArea = usableWidth * usableHeight;
    if (usableArea === 0) return 0;
    let filledArea = 0;
    for (const placement of placements){
        const w = placement.rotated ? placement.panel.height : placement.panel.width;
        const h = placement.rotated ? placement.panel.width : placement.panel.height;
        filledArea += w * h;
    }
    return Math.round(filledArea / usableArea * 100);
}
function $60c3b581f75a020b$export$1da3022013207d74(panels, config = $60c3b581f75a020b$export$dbae94b378a6c4a2) {
    const usable = $60c3b581f75a020b$export$e2b09b029fd57ee9(config);
    const instances = $60c3b581f75a020b$var$expandAndSortPanels(panels);
    const boards = [];
    const unplaceable = [];
    // Track free rectangles for each board
    const boardFreeRects = [];
    for (const instance of instances){
        const { panel: panel, instanceIndex: instanceIndex, width: width, height: height } = instance;
        // Check if panel can fit on a board at all
        const fitsNormal = width <= usable.width && height <= usable.height;
        const fitsRotated = height <= usable.width && width <= usable.height;
        if (!fitsNormal && !fitsRotated) {
            const minWidth = width + 2 * config.margin;
            const minHeight = height + 2 * config.margin;
            unplaceable.push({
                panel: panel,
                instanceIndex: instanceIndex,
                reason: `${panel.boxName}.${panel.label} (${width}\xd7${height}mm) exceeds usable board area (${usable.width}\xd7${usable.height}mm). Minimum board size needed: ${minWidth}\xd7${minHeight}mm`
            });
            continue;
        }
        // Try to fit in existing boards
        let placed = false;
        for(let boardIdx = 0; boardIdx < boards.length; boardIdx++){
            const freeRects = boardFreeRects[boardIdx];
            const fit = $60c3b581f75a020b$var$findBestFit(width, height, freeRects, config.kerf);
            if (fit) {
                const rect = freeRects[fit.rectIndex];
                const placedWidth = fit.rotated ? height : width;
                const placedHeight = fit.rotated ? width : height;
                // Place the panel
                boards[boardIdx].placements.push({
                    panel: panel,
                    instanceIndex: instanceIndex,
                    x: rect.x,
                    y: rect.y,
                    rotated: fit.rotated
                });
                // Remove the used rectangle and add new ones from the split
                freeRects.splice(fit.rectIndex, 1);
                const newRects = $60c3b581f75a020b$var$guillotineSplit(rect, placedWidth, placedHeight, config.kerf);
                freeRects.push(...newRects);
                placed = true;
                break;
            }
        }
        // Create a new board if needed
        if (!placed) {
            const newBoardId = boards.length + 1;
            const initialRect = {
                x: 0,
                y: 0,
                width: usable.width,
                height: usable.height
            };
            // Determine if rotation is needed for initial placement
            let rotated = false;
            if (width > usable.width || height > usable.height) rotated = true;
            const placedWidth = rotated ? height : width;
            const placedHeight = rotated ? width : height;
            const newBoard = {
                id: newBoardId,
                placements: [
                    {
                        panel: panel,
                        instanceIndex: instanceIndex,
                        x: 0,
                        y: 0,
                        rotated: rotated
                    }
                ],
                efficiency: 0
            };
            boards.push(newBoard);
            // Create free rectangles from the split
            const newRects = $60c3b581f75a020b$var$guillotineSplit(initialRect, placedWidth, placedHeight, config.kerf);
            boardFreeRects.push(newRects);
        }
    }
    // Calculate efficiency for each board
    for (const board of boards)board.efficiency = $60c3b581f75a020b$var$calculateEfficiency(board.placements, usable.width, usable.height);
    return {
        boards: boards,
        unplaceable: unplaceable,
        config: config
    };
}



/**
 * Wrap text to fit within a maximum number of characters per line.
 * Tries to break at sensible points (spaces, dots, hyphens).
 */ function $aa1db0b089ef7146$export$db1d31f4af680217(text, maxCharsPerLine) {
    // Guard against infinite loop with tiny panels
    if (maxCharsPerLine <= 0) return [
        text
    ];
    if (text.length <= maxCharsPerLine) return [
        text
    ];
    const lines = [];
    let remaining = text;
    while(remaining.length > 0){
        if (remaining.length <= maxCharsPerLine) {
            lines.push(remaining);
            break;
        }
        let breakPoint = maxCharsPerLine;
        const searchArea = remaining.slice(0, maxCharsPerLine);
        const lastSpace = searchArea.lastIndexOf(" ");
        const lastDot = searchArea.lastIndexOf(".");
        const lastHyphen = searchArea.lastIndexOf("-");
        const bestBreak = Math.max(lastSpace, lastDot + 1, lastHyphen + 1);
        if (bestBreak > maxCharsPerLine * 0.4) breakPoint = bestBreak;
        lines.push(remaining.slice(0, breakPoint).trim());
        remaining = remaining.slice(breakPoint).trim();
    }
    return lines;
}


const $2f4cd9ba4fceb80d$export$fdc1fca34fd579a4 = '<svg width="1em" height="1em" viewBox="0 0 24 24" style="vertical-align: middle; display: inline-block;"><path d="M12 2L1 21h22L12 2z" fill="#f0ad4e" stroke="#1a1a1a" stroke-width="1.5" stroke-linejoin="round"/><text x="12" y="18" text-anchor="middle" font-size="14" font-weight="bold" fill="#1a1a1a" font-family="sans-serif">!</text></svg>';
function $2f4cd9ba4fceb80d$export$6e22a988ee9ea289(boxes, container, onRemove, onQuantityChange, oversizedBoxes, boardConfig, onEdit) {
    if (boxes.length === 0) {
        container.innerHTML = '<p class="text-sm opacity-60">Add a box to start.</p>';
        return;
    }
    container.innerHTML = boxes.map((box, index)=>`
      <div class="tech-box-item flex items-center justify-between">
        <div class="flex items-center gap-2">
          ${oversizedBoxes?.has(index) ? `<span title="This box has panels too large for the configured board size (${boardConfig ? `${boardConfig.width}\u00d7${boardConfig.height}mm` : ''})" style="cursor: help; display: inline-flex; align-items: center;">${$2f4cd9ba4fceb80d$export$fdc1fca34fd579a4}</span>` : ''}
          <span class="font-medium">${$2f4cd9ba4fceb80d$export$4cf11838cdc2a8a8(box.name)}</span>
          <span class="opacity-60">
            ${box.width} \xd7 ${box.depth} \xd7 ${box.height}
          </span>
        </div>
        <div class="flex items-center gap-3">
          <label class="flex items-center gap-1 text-xs uppercase">
            Qty:
            <input
              type="number"
              data-index="${index}"
              value="${box.quantity}"
              min="1"
              class="quantity-input tech-input w-14 text-center"
            />
          </label>
          <button
            data-index="${index}"
            class="edit-box-btn tech-remove"
          >
            Edit
          </button>
          <button
            data-index="${index}"
            class="remove-box-btn tech-remove"
          >
            Remove
          </button>
        </div>
      </div>
    `).join("");
    container.querySelectorAll(".remove-box-btn").forEach((btn)=>{
        btn.addEventListener("click", (e)=>{
            const index = parseInt(e.target.dataset.index || "0", 10);
            onRemove(index);
        });
    });
    if (onEdit) container.querySelectorAll(".edit-box-btn").forEach((btn)=>{
        btn.addEventListener("click", (e)=>{
            const index = parseInt(e.target.dataset.index || "0", 10);
            onEdit(index);
        });
    });
    if (onQuantityChange) container.querySelectorAll(".quantity-input").forEach((input)=>{
        input.addEventListener("change", (e)=>{
            const target = e.target;
            const index = parseInt(target.dataset.index || "0", 10);
            const quantity = Math.max(1, parseInt(target.value, 10) || 1);
            target.value = String(quantity);
            onQuantityChange(index, quantity);
        });
    });
}
function $2f4cd9ba4fceb80d$export$c072f8405301a667(panels, thickness, container) {
    // Group panels by box name
    const grouped = new Map();
    for (const panel of panels){
        const existing = grouped.get(panel.boxName) || [];
        existing.push(panel);
        grouped.set(panel.boxName, existing);
    }
    let html = "";
    for (const [boxName, boxPanels] of grouped)html += `
      <div class="mb-4">
        <h3 class="text-xs uppercase tracking-wide font-semibold mb-3 border-b border-current pb-1">${$2f4cd9ba4fceb80d$export$4cf11838cdc2a8a8(boxName)}</h3>
        <table class="w-full text-sm">
          <thead>
            <tr class="border-b border-current">
              <th class="text-left py-1 text-xs uppercase tracking-wide font-normal">Panel</th>
              <th class="text-left py-1 text-xs uppercase tracking-wide font-normal">Size (mm)</th>
              <th class="text-left py-1 text-xs uppercase tracking-wide font-normal">Qty</th>
            </tr>
          </thead>
          <tbody>
            ${boxPanels.map((panel)=>`
              <tr class="border-b border-dashed border-gray-300">
                <td class="py-1">${$2f4cd9ba4fceb80d$export$4cf11838cdc2a8a8(panel.label)}</td>
                <td class="py-1">${panel.width} \xd7 ${panel.height}</td>
                <td class="py-1">${panel.quantity}</td>
              </tr>
            `).join("")}
          </tbody>
        </table>
      </div>
    `;
    container.innerHTML = html;
}
function $2f4cd9ba4fceb80d$export$4cf11838cdc2a8a8(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
}
// Colors and hatch patterns for technical drawing look
const $2f4cd9ba4fceb80d$var$PANEL_COLORS = [
    "#2563eb",
    "#16a34a",
    "#dc2626",
    "#9333ea",
    "#ea580c",
    "#0891b2",
    "#c026d3",
    "#854d0e"
];
const $2f4cd9ba4fceb80d$var$HATCH_ANGLES = [
    45,
    -45,
    0,
    90,
    30,
    -30,
    60,
    -60
];
function $2f4cd9ba4fceb80d$var$getPanelStyle(index) {
    return {
        color: $2f4cd9ba4fceb80d$var$PANEL_COLORS[index % $2f4cd9ba4fceb80d$var$PANEL_COLORS.length],
        angle: $2f4cd9ba4fceb80d$var$HATCH_ANGLES[index % $2f4cd9ba4fceb80d$var$HATCH_ANGLES.length]
    };
}
function $2f4cd9ba4fceb80d$export$fa0d7de1e4b8cd2f(config, container) {
    const usable = (0, $60c3b581f75a020b$export$e2b09b029fd57ee9)(config);
    container.innerHTML = `
    <div class="border border-current p-3 text-sm">
      <p class="text-xs uppercase tracking-wide font-semibold mb-2">Board Configuration</p>
      <ul class="space-y-1 text-sm">
        <li>Board size: ${config.width} \xd7 ${config.height} mm</li>
        <li>Edge margin: ${config.margin}mm on each edge</li>
        <li>Usable area: ${usable.width} \xd7 ${usable.height} mm</li>
        <li>Cut kerf: ${config.kerf}mm between panels</li>
      </ul>
    </div>
  `;
}
function $2f4cd9ba4fceb80d$export$a70f0cd475880760(result, container) {
    if (result.unplaceable.length === 0) {
        container.innerHTML = "";
        return;
    }
    const warnings = result.unplaceable.map((item)=>`<li>${$2f4cd9ba4fceb80d$export$4cf11838cdc2a8a8(item.reason)}</li>`).join("");
    container.innerHTML = `
    <div class="border-2 border-current p-3 text-sm mb-4">
      <p class="text-xs uppercase tracking-wide font-semibold mb-2">${$2f4cd9ba4fceb80d$export$fdc1fca34fd579a4} Warnings</p>
      <ul class="space-y-1 list-disc list-inside">
        ${warnings}
      </ul>
    </div>
  `;
}
function $2f4cd9ba4fceb80d$export$5f63f83b53730129(result, container) {
    if (result.boards.length === 0) {
        container.innerHTML = '<p class="text-sm opacity-60">No panels to display.</p>';
        return;
    }
    const config = result.config;
    // Scale factor: fit board to max 600px width
    const maxWidth = 600;
    const scale = Math.min(1, maxWidth / config.width);
    const svgWidth = config.width * scale;
    const svgHeight = config.height * scale;
    // Create a pattern index map for unique panel labels
    const labelPatternMap = new Map();
    let patternIndex = 0;
    for (const board of result.boards)for (const placement of board.placements){
        const key = `${placement.panel.boxName}:${placement.panel.label}`;
        if (!labelPatternMap.has(key)) labelPatternMap.set(key, patternIndex++);
    }
    // Generate hatch pattern definitions
    const patternDefs = Array.from(labelPatternMap.entries()).map(([, idx])=>{
        const style = $2f4cd9ba4fceb80d$var$getPanelStyle(idx);
        const patternId = `hatch-${idx}`;
        const spacing = 10;
        return `
      <pattern id="${patternId}" patternUnits="userSpaceOnUse" width="${spacing}" height="${spacing}" patternTransform="rotate(${style.angle})">
        <line x1="0" y1="0" x2="0" y2="${spacing}" stroke="${style.color}" stroke-width="0.5" stroke-opacity="0.3" />
      </pattern>
    `;
    }).join("");
    // Summary
    let html = `
    <div class="border p-3 mb-4 text-sm">
      <span class="text-xs uppercase tracking-wide">Total boards needed:</span>
      <span class="font-bold ml-2">${result.boards.length}</span>
    </div>
  `;
    for (const board of result.boards)html += `
      <div class="p-3 mb-4">
        <div class="mb-2 text-xs uppercase tracking-wide">
          Board ${board.id}
        </div>
        <svg
          width="${svgWidth}"
          height="${svgHeight}"
          viewBox="0 0 ${config.width} ${config.height}"
          class="bg-white"
        >
          <defs>
            ${patternDefs}
          </defs>
          <!-- Board outline -->
          <rect x="0" y="0" width="${config.width}" height="${config.height}" fill="none" stroke="#1a1a1a" stroke-width="2" />
          <!-- Margin area (dashed) -->
          <rect x="${config.margin}" y="${config.margin}" width="${config.width - 2 * config.margin}" height="${config.height - 2 * config.margin}" fill="none" stroke="#1a1a1a" stroke-width="0.5" stroke-dasharray="4 2" />
          <!-- Placed panels -->
          ${board.placements.map((placement)=>$2f4cd9ba4fceb80d$var$renderPlacedPanel(placement, config.margin, labelPatternMap)).join("")}
        </svg>
      </div>
    `;
    container.innerHTML = html;
}
function $2f4cd9ba4fceb80d$var$renderPlacedPanel(placement, margin, patternMap) {
    const { panel: panel, x: x, y: y, rotated: rotated, instanceIndex: instanceIndex } = placement;
    const w = rotated ? panel.height : panel.width;
    const h = rotated ? panel.width : panel.height;
    const key = `${panel.boxName}:${panel.label}`;
    const patternIdx = patternMap.get(key) ?? 0;
    const patternId = `hatch-${patternIdx}`;
    const style = $2f4cd9ba4fceb80d$var$getPanelStyle(patternIdx);
    // Calculate position including margin
    const px = margin + x;
    const py = margin + y;
    // Font size scaled for readability
    const fontSize = Math.min(11, Math.max(7, Math.min(w, h) * 0.12));
    const dimFontSize = Math.max(6, fontSize * 0.85);
    const lineHeight = fontSize * 1.2;
    // Create label: "BoxName.Side" format
    const baseLabelText = `${panel.boxName}.${panel.label}`;
    const labelText = panel.quantity > 1 ? `${baseLabelText} (${instanceIndex + 1})` : baseLabelText;
    // Wrap text to fit panel width (with padding)
    const padding = 6;
    const maxCharsPerLine = Math.floor((w - padding * 2) / (fontSize * 0.55));
    const lines = (0, $aa1db0b089ef7146$export$db1d31f4af680217)(labelText, maxCharsPerLine);
    // Limit lines to fit in panel height (with padding)
    const maxLines = Math.floor((h - padding * 2 - dimFontSize) / lineHeight);
    const displayLines = lines.slice(0, Math.max(1, maxLines));
    if (displayLines.length < lines.length) {
        const lastLine = displayLines[displayLines.length - 1];
        displayLines[displayLines.length - 1] = lastLine.slice(0, -1) + "\u2026";
    }
    // Dimensions text (always show original panel dimensions, not rotated)
    const dimText = `${panel.width}\xd7${panel.height}`;
    // Calculate vertical centering for text block
    const totalTextHeight = displayLines.length * lineHeight + dimFontSize;
    const textStartY = py + (h - totalTextHeight) / 2 + fontSize * 0.8;
    const labelTspans = displayLines.map((line, i)=>`<tspan x="${px + w / 2}" dy="${i === 0 ? 0 : lineHeight}">${$2f4cd9ba4fceb80d$export$4cf11838cdc2a8a8(line)}</tspan>`).join("");
    return `
    <g>
      <rect
        x="${px}"
        y="${py}"
        width="${w}"
        height="${h}"
        fill="white"
      />
      <rect
        x="${px}"
        y="${py}"
        width="${w}"
        height="${h}"
        fill="url(#${patternId})"
        stroke="${style.color}"
        stroke-width="1.5"
      />
      <text
        x="${px + w / 2}"
        y="${textStartY}"
        text-anchor="middle"
        font-size="${fontSize}"
        fill="#1a1a1a"
        font-family="ui-monospace, monospace"
      >${labelTspans}</text>
      <text
        x="${px + w / 2}"
        y="${textStartY + displayLines.length * lineHeight}"
        text-anchor="middle"
        font-size="${dimFontSize}"
        fill="#4a4a4a"
        font-family="ui-monospace, monospace"
      >${dimText}</text>
    </g>
  `;
}


// Auto-name generation, returns names like 'A-Z', then 'AA-AZ', then 'BA-BZ'...
function $4e9fdb6485c33719$export$f3bce7bd17b3c429(index) {
    let name = "";
    let n = index;
    do {
        name = String.fromCharCode(65 + n % 26) + name;
        n = Math.floor(n / 26) - 1;
    }while (n >= 0);
    return `Box ${name}`;
}


// Storage
const $b4e14b6b8da86996$var$BOXES_STORAGE_KEY = "foamcore-boxes";
const $b4e14b6b8da86996$var$SETTINGS_STORAGE_KEY = "foamcore-settings";
const $b4e14b6b8da86996$var$DEFAULT_SETTINGS = {
    thickness: 5,
    kerf: 1,
    boardWidth: 700,
    boardHeight: 500
};
function $b4e14b6b8da86996$var$saveBoxes() {
    localStorage.setItem($b4e14b6b8da86996$var$BOXES_STORAGE_KEY, JSON.stringify($b4e14b6b8da86996$var$boxes));
}
function $b4e14b6b8da86996$var$loadBoxes() {
    const stored = localStorage.getItem($b4e14b6b8da86996$var$BOXES_STORAGE_KEY);
    if (!stored) return [];
    try {
        const parsed = JSON.parse(stored);
        // bare minimum check that it's an array
        if (Array.isArray(parsed)) return parsed;
        else return [];
    } catch  {
        return [];
    }
}
function $b4e14b6b8da86996$var$saveSettings() {
    const settings = {
        thickness: parseFloat($b4e14b6b8da86996$var$thicknessInput.value) || $b4e14b6b8da86996$var$DEFAULT_SETTINGS.thickness,
        kerf: parseFloat($b4e14b6b8da86996$var$boardKerfInput.value) ?? $b4e14b6b8da86996$var$DEFAULT_SETTINGS.kerf,
        boardWidth: parseFloat($b4e14b6b8da86996$var$boardWidthInput.value) || $b4e14b6b8da86996$var$DEFAULT_SETTINGS.boardWidth,
        boardHeight: parseFloat($b4e14b6b8da86996$var$boardHeightInput.value) || $b4e14b6b8da86996$var$DEFAULT_SETTINGS.boardHeight
    };
    localStorage.setItem($b4e14b6b8da86996$var$SETTINGS_STORAGE_KEY, JSON.stringify(settings));
}
function $b4e14b6b8da86996$var$loadSettings() {
    const stored = localStorage.getItem($b4e14b6b8da86996$var$SETTINGS_STORAGE_KEY);
    if (!stored) return $b4e14b6b8da86996$var$DEFAULT_SETTINGS;
    try {
        const parsed = JSON.parse(stored);
        return {
            ...$b4e14b6b8da86996$var$DEFAULT_SETTINGS,
            ...parsed
        };
    } catch  {
        return $b4e14b6b8da86996$var$DEFAULT_SETTINGS;
    }
}
function $b4e14b6b8da86996$var$getNextAutoName() {
    const pattern = /^Box ([A-Z]+)$/;
    let maxIndex = -1;
    for (const box of $b4e14b6b8da86996$var$boxes){
        const match = box.name.match(pattern);
        if (match) {
            let index = 0;
            for (const char of match[1])index = index * 26 + (char.charCodeAt(0) - 64);
            maxIndex = Math.max(maxIndex, index);
        }
    }
    return (0, $4e9fdb6485c33719$export$f3bce7bd17b3c429)(maxIndex + 1);
}
// Board config helpers
function $b4e14b6b8da86996$var$getCurrentBoardConfig() {
    return {
        width: parseFloat($b4e14b6b8da86996$var$boardWidthInput.value) || (0, $60c3b581f75a020b$export$dbae94b378a6c4a2).width,
        height: parseFloat($b4e14b6b8da86996$var$boardHeightInput.value) || (0, $60c3b581f75a020b$export$dbae94b378a6c4a2).height,
        margin: (0, $60c3b581f75a020b$export$dbae94b378a6c4a2).margin,
        kerf: parseFloat($b4e14b6b8da86996$var$boardKerfInput.value) ?? (0, $60c3b581f75a020b$export$dbae94b378a6c4a2).kerf,
        thickness: parseFloat($b4e14b6b8da86996$var$thicknessInput.value) || (0, $60c3b581f75a020b$export$dbae94b378a6c4a2).thickness
    };
}
function $b4e14b6b8da86996$var$wouldCreateOversizedPanels(box) {
    const config = $b4e14b6b8da86996$var$getCurrentBoardConfig();
    const usable = (0, $60c3b581f75a020b$export$e2b09b029fd57ee9)(config);
    const panelDims = [
        {
            w: box.width,
            h: box.height
        },
        {
            w: box.depth - 2 * config.thickness,
            h: box.height
        },
        {
            w: box.width - 2 * config.thickness,
            h: box.depth - 2 * config.thickness
        }
    ];
    return panelDims.some(({ w: w, h: h })=>{
        const fitsNormal = w <= usable.width && h <= usable.height;
        const fitsRotated = h <= usable.width && w <= usable.height;
        return !fitsNormal && !fitsRotated;
    });
}
function $b4e14b6b8da86996$var$getOversizedBoxes() {
    const oversized = new Set();
    $b4e14b6b8da86996$var$boxes.forEach((box, i)=>{
        if ($b4e14b6b8da86996$var$wouldCreateOversizedPanels(box)) oversized.add(i);
    });
    return oversized;
}
// State
const $b4e14b6b8da86996$var$boxes = $b4e14b6b8da86996$var$loadBoxes();
let $b4e14b6b8da86996$var$editingIndex = null;
// DOM elements
const $b4e14b6b8da86996$var$thicknessInput = document.getElementById("thickness");
const $b4e14b6b8da86996$var$boxNameInput = document.getElementById("box-name");
const $b4e14b6b8da86996$var$boxWidthInput = document.getElementById("box-width");
const $b4e14b6b8da86996$var$boxDepthInput = document.getElementById("box-depth");
const $b4e14b6b8da86996$var$boxHeightInput = document.getElementById("box-height");
const $b4e14b6b8da86996$var$addBoxBtn = document.getElementById("add-box-btn");
const $b4e14b6b8da86996$var$openAddBoxBtn = document.getElementById("open-add-box-btn");
const $b4e14b6b8da86996$var$cancelAddBoxBtn = document.getElementById("cancel-add-box-btn");
const $b4e14b6b8da86996$var$addBoxDialog = document.getElementById("add-box-dialog");
const $b4e14b6b8da86996$var$addBoxDialogTitle = document.getElementById("add-box-dialog-title");
const $b4e14b6b8da86996$var$boxListContainer = document.getElementById("box-list");
const $b4e14b6b8da86996$var$resultsSection = document.getElementById("results");
const $b4e14b6b8da86996$var$panelListContainer = document.getElementById("panel-list");
// Board settings elements
const $b4e14b6b8da86996$var$boardWidthInput = document.getElementById("board-width");
const $b4e14b6b8da86996$var$boardHeightInput = document.getElementById("board-height");
const $b4e14b6b8da86996$var$boardKerfInput = document.getElementById("board-kerf");
const $b4e14b6b8da86996$var$boardLayoutSection = document.getElementById("board-layout");
const $b4e14b6b8da86996$var$boardWarningsContainer = document.getElementById("board-warnings");
const $b4e14b6b8da86996$var$boardVisualizationContainer = document.getElementById("board-visualization");
const $b4e14b6b8da86996$var$addBoxWarning = document.getElementById("add-box-warning");
function $b4e14b6b8da86996$var$validateDialogBox() {
    const width = parseFloat($b4e14b6b8da86996$var$boxWidthInput.value);
    const depth = parseFloat($b4e14b6b8da86996$var$boxDepthInput.value);
    const height = parseFloat($b4e14b6b8da86996$var$boxHeightInput.value);
    if (isNaN(width) || isNaN(depth) || isNaN(height) || width <= 0 || depth <= 0 || height <= 0) {
        $b4e14b6b8da86996$var$addBoxWarning.classList.add("hidden");
        $b4e14b6b8da86996$var$addBoxBtn.disabled = false;
        return;
    }
    const testBox = {
        name: "",
        width: width,
        depth: depth,
        height: height,
        quantity: 1
    };
    if ($b4e14b6b8da86996$var$wouldCreateOversizedPanels(testBox)) {
        const config = $b4e14b6b8da86996$var$getCurrentBoardConfig();
        const usable = (0, $60c3b581f75a020b$export$e2b09b029fd57ee9)(config);
        $b4e14b6b8da86996$var$addBoxWarning.innerHTML = `${0, $2f4cd9ba4fceb80d$export$fdc1fca34fd579a4} Panels exceed usable board area (${usable.width} \u00d7 ${usable.height} mm). Either make the box smaller, or change the board size in the settings.`;
        $b4e14b6b8da86996$var$addBoxWarning.classList.remove("hidden");
        $b4e14b6b8da86996$var$addBoxBtn.disabled = true;
    } else {
        $b4e14b6b8da86996$var$addBoxWarning.classList.add("hidden");
        $b4e14b6b8da86996$var$addBoxBtn.disabled = false;
    }
}
function $b4e14b6b8da86996$var$addBox() {
    let name = $b4e14b6b8da86996$var$boxNameInput.value.trim();
    const width = parseFloat($b4e14b6b8da86996$var$boxWidthInput.value);
    const depth = parseFloat($b4e14b6b8da86996$var$boxDepthInput.value);
    const height = parseFloat($b4e14b6b8da86996$var$boxHeightInput.value);
    if (isNaN(width) || isNaN(depth) || isNaN(height)) {
        alert("Please fill in all dimension fields with valid values.");
        return;
    }
    if (width <= 0 || depth <= 0 || height <= 0) {
        alert("Dimensions must be positive numbers.");
        return;
    }
    // Auto-generate name if empty
    if (!name) name = $b4e14b6b8da86996$var$getNextAutoName();
    if ($b4e14b6b8da86996$var$editingIndex !== null) {
        const editedBox = {
            name: name,
            width: width,
            depth: depth,
            height: height,
            quantity: $b4e14b6b8da86996$var$boxes[$b4e14b6b8da86996$var$editingIndex].quantity
        };
        if ($b4e14b6b8da86996$var$wouldCreateOversizedPanels(editedBox)) return;
        $b4e14b6b8da86996$var$boxes[$b4e14b6b8da86996$var$editingIndex] = editedBox;
        $b4e14b6b8da86996$var$editingIndex = null;
    } else {
        const newBox = {
            name: name,
            width: width,
            depth: depth,
            height: height,
            quantity: 1
        };
        if ($b4e14b6b8da86996$var$wouldCreateOversizedPanels(newBox)) return;
        $b4e14b6b8da86996$var$boxes.push(newBox);
    }
    $b4e14b6b8da86996$var$saveBoxes();
    // Clear form (but keep height; it's super common to generate lots of boxes of the same height)
    $b4e14b6b8da86996$var$boxNameInput.value = "";
    $b4e14b6b8da86996$var$boxWidthInput.value = "";
    $b4e14b6b8da86996$var$boxDepthInput.value = "";
    $b4e14b6b8da86996$var$resetDialog();
    $b4e14b6b8da86996$var$addBoxDialog.close();
    $b4e14b6b8da86996$var$updateBoxList();
    $b4e14b6b8da86996$var$recalculate();
}
function $b4e14b6b8da86996$var$resetDialog() {
    $b4e14b6b8da86996$var$editingIndex = null;
    $b4e14b6b8da86996$var$addBoxDialogTitle.textContent = "Add Box";
    $b4e14b6b8da86996$var$addBoxBtn.textContent = "Add";
    $b4e14b6b8da86996$var$addBoxBtn.disabled = false;
    $b4e14b6b8da86996$var$addBoxWarning.classList.add("hidden");
}
// Event handlers
$b4e14b6b8da86996$var$openAddBoxBtn.addEventListener("click", ()=>{
    $b4e14b6b8da86996$var$resetDialog();
    $b4e14b6b8da86996$var$addBoxDialog.showModal();
});
$b4e14b6b8da86996$var$cancelAddBoxBtn.addEventListener("click", ()=>{
    $b4e14b6b8da86996$var$resetDialog();
    $b4e14b6b8da86996$var$addBoxDialog.close();
});
$b4e14b6b8da86996$var$addBoxDialog.addEventListener("close", ()=>$b4e14b6b8da86996$var$resetDialog());
$b4e14b6b8da86996$var$addBoxBtn.addEventListener("click", $b4e14b6b8da86996$var$addBox);
// Enter key support for all input fields
[
    $b4e14b6b8da86996$var$boxNameInput,
    $b4e14b6b8da86996$var$boxWidthInput,
    $b4e14b6b8da86996$var$boxDepthInput,
    $b4e14b6b8da86996$var$boxHeightInput
].forEach((input)=>{
    input.addEventListener("keydown", (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            $b4e14b6b8da86996$var$addBox();
        }
    });
});
// Real-time validation on dimension inputs
[
    $b4e14b6b8da86996$var$boxWidthInput,
    $b4e14b6b8da86996$var$boxDepthInput,
    $b4e14b6b8da86996$var$boxHeightInput
].forEach((input)=>{
    input.addEventListener("input", $b4e14b6b8da86996$var$validateDialogBox);
});
// Recalculate panels and board layout
function $b4e14b6b8da86996$var$recalculate() {
    if ($b4e14b6b8da86996$var$boxes.length === 0) {
        $b4e14b6b8da86996$var$resultsSection.classList.add("hidden");
        $b4e14b6b8da86996$var$boardLayoutSection.classList.add("hidden");
        return;
    }
    const boardConfig = $b4e14b6b8da86996$var$getCurrentBoardConfig();
    if (boardConfig.thickness <= 0 || boardConfig.width <= 0 || boardConfig.height <= 0 || boardConfig.kerf < 0) return;
    const panels = (0, $995b230258b46624$export$236cfce0883632ce)($b4e14b6b8da86996$var$boxes, boardConfig.thickness);
    (0, $2f4cd9ba4fceb80d$export$c072f8405301a667)(panels, boardConfig.thickness, $b4e14b6b8da86996$var$panelListContainer);
    $b4e14b6b8da86996$var$resultsSection.classList.remove("hidden");
    const packingResult = (0, $60c3b581f75a020b$export$1da3022013207d74)(panels, boardConfig);
    (0, $2f4cd9ba4fceb80d$export$a70f0cd475880760)(packingResult, $b4e14b6b8da86996$var$boardWarningsContainer);
    (0, $2f4cd9ba4fceb80d$export$5f63f83b53730129)(packingResult, $b4e14b6b8da86996$var$boardVisualizationContainer);
    $b4e14b6b8da86996$var$boardLayoutSection.classList.remove("hidden");
}
// Settings change listeners
$b4e14b6b8da86996$var$boardWidthInput.addEventListener("input", ()=>{
    $b4e14b6b8da86996$var$saveSettings();
    $b4e14b6b8da86996$var$updateBoxList();
    $b4e14b6b8da86996$var$recalculate();
});
$b4e14b6b8da86996$var$boardHeightInput.addEventListener("input", ()=>{
    $b4e14b6b8da86996$var$saveSettings();
    $b4e14b6b8da86996$var$updateBoxList();
    $b4e14b6b8da86996$var$recalculate();
});
$b4e14b6b8da86996$var$boardKerfInput.addEventListener("input", ()=>{
    $b4e14b6b8da86996$var$saveSettings();
    $b4e14b6b8da86996$var$recalculate();
});
$b4e14b6b8da86996$var$thicknessInput.addEventListener("input", ()=>{
    $b4e14b6b8da86996$var$saveSettings();
    $b4e14b6b8da86996$var$updateBoxList();
    $b4e14b6b8da86996$var$recalculate();
});
function $b4e14b6b8da86996$var$updateBoxList() {
    const oversizedBoxes = $b4e14b6b8da86996$var$getOversizedBoxes();
    (0, $2f4cd9ba4fceb80d$export$6e22a988ee9ea289)($b4e14b6b8da86996$var$boxes, $b4e14b6b8da86996$var$boxListContainer, (index)=>{
        $b4e14b6b8da86996$var$boxes.splice(index, 1);
        $b4e14b6b8da86996$var$saveBoxes();
        $b4e14b6b8da86996$var$updateBoxList();
        $b4e14b6b8da86996$var$recalculate();
    }, (index, quantity)=>{
        $b4e14b6b8da86996$var$boxes[index].quantity = quantity;
        $b4e14b6b8da86996$var$saveBoxes();
        $b4e14b6b8da86996$var$recalculate();
    }, oversizedBoxes, $b4e14b6b8da86996$var$getCurrentBoardConfig(), (index)=>{
        $b4e14b6b8da86996$var$editingIndex = index;
        const box = $b4e14b6b8da86996$var$boxes[index];
        $b4e14b6b8da86996$var$boxNameInput.value = box.name;
        $b4e14b6b8da86996$var$boxWidthInput.value = String(box.width);
        $b4e14b6b8da86996$var$boxDepthInput.value = String(box.depth);
        $b4e14b6b8da86996$var$boxHeightInput.value = String(box.height);
        $b4e14b6b8da86996$var$addBoxDialogTitle.textContent = "Edit Box";
        $b4e14b6b8da86996$var$addBoxBtn.textContent = "Save";
        $b4e14b6b8da86996$var$addBoxDialog.showModal();
        $b4e14b6b8da86996$var$validateDialogBox();
    });
}
// Load settings from storage
const $b4e14b6b8da86996$var$savedSettings = $b4e14b6b8da86996$var$loadSettings();
$b4e14b6b8da86996$var$thicknessInput.value = String($b4e14b6b8da86996$var$savedSettings.thickness);
$b4e14b6b8da86996$var$boardKerfInput.value = String($b4e14b6b8da86996$var$savedSettings.kerf);
$b4e14b6b8da86996$var$boardWidthInput.value = String($b4e14b6b8da86996$var$savedSettings.boardWidth);
$b4e14b6b8da86996$var$boardHeightInput.value = String($b4e14b6b8da86996$var$savedSettings.boardHeight);
// Render any boxes loaded from storage and calculate
$b4e14b6b8da86996$var$updateBoxList();
$b4e14b6b8da86996$var$recalculate();
var $134afa45a942db6b$exports = {};
$134afa45a942db6b$exports = import.meta.resolve("7yE4W");


// Register service worker (production only)
if ("serviceWorker" in navigator && true) navigator.serviceWorker.register($134afa45a942db6b$exports);


//# sourceMappingURL=repo.abc83379.js.map
